import { createStore } from 'vuex'

import user from './user.module'
import people from './people.module.js'
import board from './board.module'
import settings from './settings.module'
import importData from './importData.module'
import forex from './forex.module'
import syncScenario from './syncScenario.module'
import ppt from './ppt.module'
import impactPlannedChanges from './impactPlannedChanges.module'
import workforceHubCharts from './workforceHubCharts.module'
import operatingModel from './operatingModel.module'
import meta from './meta.module'
import sensitiveData from './sensitiveData.module'
import customFields from './customFields.module'
import accessScopes from './accessScopes.module'
import comments from './comments.module'
import branding from './branding.module'
import cardContent from './cardContent.module'
import recentInvites from './recentInvites.module'
import defaultViews from './defaultViews.module'
import region from './region.module'

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    people,
    user,
    board,
    settings,
    importData,
    forex,
    impactPlannedChanges,
    workforceHubCharts,
    syncScenario,
    operatingModel,
    meta,
    ppt,
    sensitiveData,
    customFields,
    accessScopes,
    comments,
    branding,
    cardContent,
    recentInvites,
    defaultViews,
    region
  }
})
